$(document).ready(function(){
	$('.slick-intro').slick({
		dots: true,
		arrows: false,
		fade: true,
		infinite: true,
		autoplay: true,
	});

	// slick agenda
	$('.slick-agenda').slick({
		dots: false,
		arrows: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		],
	});

	// equalize height of agenda slider items
	$('.slick-agenda').on('setPosition', function () {
		$(this).find('.slick-slide').height('auto');
		var slickTrack = $(this).find('.slick-track');
		var slickTrackHeight = $(slickTrack).height();
		$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
	});

	
	// slick news
	$('.slick-news').slick({
		dots: true,
		appendDots: '.slider-news .slick-action',
		arrows: true,
		fade: true,
		autoplay: true,
		autoplaySpeed: 3000,
		prevArrow: '.slider-news .slick-action .btn-prev',
		nextArrow: '.slider-news .slick-action .btn-next',
		//fade: true,
		infinite: true,
	});

	var PauseIsActive = false;

	$('.slider-news .btn-pause').on('click', function(event) {
		event.preventDefault();

		$(this).toggleClass('active');
		PauseIsActive = !PauseIsActive;

		if (PauseIsActive) {
			$('.slick-news').slick('slickPlay');
		} else {
			$('.slick-news').slick('slickPause');
		}
	});
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/slider/index.js
 **/